import { Box, Typography } from '@mui/material';
import React from 'react';

export default function SectionHeader({ title, icon }) {
  return (
    <Box display="flex" alignItems="center" mb={2}>
      <Box sx={{ mr: 1, color: 'primary.main' }}>{icon}</Box>
      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.2rem' }}>
        {title}
      </Typography>
    </Box>
  );
}
